<h3 i18n="@@titleUsers">Users</h3>

<mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
	<mat-label i18n="@@SearchUser">Search user</mat-label>
	<input matInput (input)="onSearchInput($any($event.target).value)" [value]="searchQuery()" />
	@if (usersLoading()) {
		<mat-spinner matSuffix diameter="20" />
	} @else {
		<mat-icon matSuffix>search</mat-icon>
	}
</mat-form-field>

@if (usersLoaded()) {
	@if (pagedUsers().length > 0) {
		<div class="table-wrap">
		<table mat-table [dataSource]="pagedUsers()">
			<ng-container matColumnDef="email">
				<th mat-header-cell *matHeaderCellDef i18n="@@labelEmail">Email</th>
				<td mat-cell *matCellDef="let user">{{ user.email }}</td>
			</ng-container>
			<ng-container matColumnDef="enabled">
				<th mat-header-cell *matHeaderCellDef i18n="@@labelEnabled">Enabled</th>
				<td mat-cell *matCellDef="let user">{{ user.enabled ? '✓' : '✗' }}</td>
			</ng-container>
			<ng-container matColumnDef="creationDate">
				<th mat-header-cell *matHeaderCellDef i18n="@@labelCreationDate">Created</th>
				<td mat-cell *matCellDef="let user">{{ user.creationDate | date:'dd-MM-yyyy' }}</td>
			</ng-container>
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let user">
					<button mat-icon-button [matMenuTriggerFor]="userMenu" #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
						<mat-icon>more_vert</mat-icon>
					</button>
					<mat-menu #userMenu="matMenu">
						<button mat-menu-item (click)="menuTrigger.closeMenu(); openGroupsDialog(user)">
							<mat-icon>group</mat-icon>
							<span i18n="@@ManageGroups">Manage groups</span>
						</button>
						<button mat-menu-item (click)="menuTrigger.closeMenu(); openDeleteDialog(user)">
							<mat-icon color="warn">delete</mat-icon>
							<span i18n="@@DeleteUser">Delete user</span>
						</button>
					</mat-menu>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="userColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: userColumns;"></tr>
		</table>
		</div>

		@if (hasPrevPage() || hasNextPage()) {
			<div class="pagination">
				<button mat-icon-button (click)="prevPage()" [disabled]="!hasPrevPage() || usersLoading()">
					<mat-icon>chevron_left</mat-icon>
				</button>
				@if (usersLoading()) {
					<mat-spinner diameter="20" />
				} @else {
					<span i18n="@@pageN">Page {{ currentPage() }}</span>
				}
				<button mat-icon-button (click)="nextPage()" [disabled]="!hasNextPage() || usersLoading()">
					<mat-icon>chevron_right</mat-icon>
				</button>
			</div>
		}
	} @else if (!usersLoading()) {
		<p i18n="@@NoUsersFound">No users found.</p>
	}
} @else {
	<mat-spinner />
}
